import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faInfo,
  faSortUp,
  faSortDown,
  faSort,
  faFilter,
  faCheck,
  faBars,
  faTimes,
  faArrowCircleLeft,
  faAngleLeft,
  faEllipsisV,
  faReply,
  faRedo,
  faSearch,
  faBookmark,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { faCircle, faUser } from "@fortawesome/free-regular-svg-icons";
// import { faGooglePlus } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// import { fab } from '@fortawesome/free-brands-svg-icons'
// library.add(fab)

library.add([
  faInfo,
  faSortUp,
  faSortDown,
  faSort,
  faFilter,
  faCheck,
  faBars,
  faCircle,
  faTimes,
  faArrowCircleLeft,
  faAngleLeft,
  faEllipsisV,
  faReply,
  faRedo,
  faSearch,
  faBookmark,
  faTrash,
  faUser,
]);
// dom.watch();
Vue.component("font-awesome-icon", FontAwesomeIcon);
